import { apiClient, requiresAuth } from '../client';
import { Idea } from '../../types';

export const ideasService = {
  getAllIdeas: async () => {
    return requiresAuth(async () => {
      const response = await apiClient.get('/ideas');
      return response.data;
    });
  },

  getIdeaById: async (ideaId: string) => {
    return requiresAuth(async () => {
      const response = await apiClient.get(`/ideas/${ideaId}`);
      return response.data;
    });
  },

  createIdea: async (ideaData: Partial<Idea>) => {
    return requiresAuth(async () => {
      const response = await apiClient.post('/ideas', ideaData);
      return response.data;
    });
  },

  updateIdea: async (ideaId: string, ideaData: Partial<Idea>) => {
    return requiresAuth(async () => {
      const response = await apiClient.put(`/ideas/${ideaId}`, ideaData);
      return response.data;
    });
  },

  deleteIdea: async (ideaId: string) => {
    return requiresAuth(async () => {
      const response = await apiClient.delete(`/ideas/${ideaId}`);
      return response.data;
    });
  },
};
